import axios from "axios";

export const getStripeAccountId = async (invoiceId: number) => {
  const res = await axios.get(
    `${process.env.REACT_APP_API}/api/v1/consumer/invoices/company-stripe-id/${invoiceId}`
  );
  return res.data;
};
